import React from "react";
import { NavLink } from "react-router-dom";
import "./ad.css";
import {
  FaHome,
  FaUserFriends,
  FaCog,
  FaAngleLeft,
  FaAngleRight,
  FaUserTie, 
} from "react-icons/fa";

export default function Sidebar({ collapsed, setCollapsed }) {
  const toggleSidebar = () => setCollapsed(!collapsed);

  const navItems = [
    { icon: <FaHome />, to: "/" },
    { icon: <FaUserFriends />, to: "/users" },
    { icon: <FaCog />, to: "/settings" },
    { icon: <FaUserTie />, to: "/counsellors" },
  ];

  return (
    <div className={`sidebar-ad ${collapsed ? "collapsed-ad" : ""}`}>
      <div className="toggle-btn-ad" onClick={toggleSidebar}>
        {/* {collapsed ? <FaAngleRight /> : <FaAngleLeft />} */}
      </div>

      <nav className="nav-links-ad">
        {navItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.to}
            className={({ isActive }) =>
              `nav-item-ad ${isActive ? "active-ad" : ""}`
            }
          >
            <span className="icon-ad">{item.icon}</span>
            {/* <span className="label-ad">{item.label}</span> */}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
